import styled from "styled-components";
import colors from "../../../../../../config/colors";

export const ConnectionCardContainer = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 50px 0px rgba(151, 140, 140, 0.2);
  min-height: 340px;
  margin-bottom: 15px;
  max-width: 20%;
  width: 100%;
  @media (max-width: 1200px) {
    max-width: 50%;
  }
  @media (max-width: 640px) {
    max-width: 100%;
  }
`;

export const ConnectionImage = styled.div`
  background-image: url(${(props) => props.image});
  width: 100%;
  height: 215px;
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 100px 10px rgba(0, 0, 0, 0.9);
  border-radius: 10px 10px 0px 0px;
  background-position: top;
`;
export const ConnectionLine = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  color: #fff;
`;

export const ConnectionName = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: 16px 0 24px;
`;
export const ConnectionActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const TaskCounter = styled.div`
  background: #fff;
  border-radius: 100px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #44449b;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ConnectButton = styled.button`
  display: flex;
  height: 40px;
  padding: 5px 9px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 3px;
  background: #44449b;
  border: none;
  color: #fff;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
`;
